import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import { MobileContext } from 'context';
import '../popups.scss';


function PopupGeneric(props) {
  const isMobile = useContext(MobileContext);

  if (props.isShown)
    return (<React.Fragment>
      <div className='Popup Overlay' onClick={props.ClosePopup} />
      <div className={'Popup Generic' + (isMobile ? ' Mobile' : ' ')}>
        <div id='header'>
          <h2>{props.title}</h2>
          <button id='close' onClick={props.ClosePopup}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
        {[props.children]}
      </div>
    </React.Fragment>);
  else
    return null;
}


export default PopupGeneric;